export enum NotificationTabEnum {
  TEAM = 'team',
  MY_TASKS = 'myTasks',
}

export default NotificationTabEnum
